import { pieveLogoPaths } from './pieveLogo/pieveLogoPaths.js';

/** The pieve. wordmark. Letters take the text color; the dot is the coral signature. */
const PieveWordmark = ({ height = 24 }) => {
  const { wordmarkViewBox, wordmarkLetters, wordmarkDot } = pieveLogoPaths;
  return (
    <svg className="comp-pieve-wordmark" height={height} viewBox={wordmarkViewBox} role="img" aria-label="Pieve">
      <path d={wordmarkLetters} fill="currentColor" />
      <circle cx={wordmarkDot.cx} cy={wordmarkDot.cy} r={wordmarkDot.r} className="comp-pieve-wordmark__dot" />
    </svg>
  );
};

export default PieveWordmark;
